const logs = {
  name: 'Device logs',
  title: 'Device logs',
  selectGroup: 'Group',
  selectGroupHint: 'Select a group to filter properties',
  selectHotel: 'Property',
  selectHotelHint: 'Select a property to filter dispensers',
  selectDevice: 'Select a device',
  selectDeviceHint: 'Select a device to view its logs',
  noDeviceSelected: 'No device selected',
  noDeviceSelectedHint: 'Select a device from Filters to view its logs.',
  noLogs: 'No logs found for this device',
  noLogsHint: 'The device may not have sent any logs yet, or the logging service may be unavailable.',
  seqError: 'Could not retrieve the device logs',
  unavailable: 'The device logs are not available right now. Please try again later.',
  level: 'Level',
  allLevels: 'All levels',
  from: 'From',
  to: 'To',
  count: 'Max results',
  refresh: 'Refresh',
  component: 'Component',
  origin: 'Origin',
  firmware: 'Firmware',
  serialNumber: 'Serial Number',
  result: 'Result',
  transaction: 'Transaction',
  steps: 'Steps',
  step: 'Step %{number}',
  properties: 'Properties',
  loading: 'Loading logs...',
  loadingInitial: 'Loading devices...',

  // Tabs
  tabs: {
    device: 'Devices',
    processing: 'Flows',
    errors: 'Errors',
    apicalls: 'API Calls',
    search: 'Search',
  },

};
export default logs;
